<template>
  <section class="btn_main_wrap">
    <p class="btn-title">
      {{ title }}
      <a v-if="lightBoxCopy.title" class="info-button_popin" @click="togglePopin">
        <svg class="icon-info_small">
          <use xlink:href="#icon-Info_small" />
        </svg>
      </a>
    </p>
    <div class="single-choice" :data-tracking-id="dtmTitle">
      <span>{{item}}</span>
    </div>
    <lightbox :visible="lightboxVisible" v-on:close="lightboxVisible = false">
      <div class="lightbox-simple-content">
        <ul>
          <li>
            <span v-html="lightBoxCopy.title" />
            <p v-html="lightBoxCopy.subtitle" />
          </li>
        </ul>
      </div>
    </lightbox>
  </section>
</template>
<script>
import { mapState } from "vuex";
import Lightbox from "@/components/shared/LightBox";
export default {
  props: {
    title: String,
    item: String,
    lightBoxCopy: Object,
    dtmTitle: String
  },
  data() {
    return {
      lightboxVisible: false,
      lengthObj: ""
    };
  },
  components: {
    Lightbox
  },
  computed: {
    ...mapState({})
  },
  
  methods: {
    togglePopin() {
      this.lightboxVisible = !this.lightboxVisible;
    },
  }
};
</script>